<template>
  <div class="image-with-desc">
    <div class="image-with-desc__outer-content">
      <router-link
        :to="noRoute ? '' : $store.getters['main/getSingleUrl'](data)"
        class="image-with-desc__img"
      >
        <picture>
          <source
            media="(max-width: 767px)"
            :srcset="_.get(data, 'image[0].devices.mobile')"
          />
          <source
            media="(max-width: 1023px)"
            :srcset="_.get(data, 'image[0].devices.tablet')"
          />
          <img
            :src="_.get(data, 'image[0].devices.desktop')"
            loading="lazy"
            alt
          />
        </picture>
      </router-link>
      <div class="image-with-desc__content">
        <router-link
          :to="noRoute ? '' : $store.getters['main/getSingleUrl'](data)"
          class="image-with-desc__title font-18 tbc-bold"
        >
          {{ _.get(data, "title") }}
        </router-link>
        <div class="image-with-desc__teaser font-16 text-overflow--line4">
          {{ _.get(data, "teaser") }}
        </div>
      </div>
    </div>

    <div
      class="view-more animated-link animated-link-a flex-box al-center"
      v-if="_.get(data, 'moreLink.title')"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
      >
        <path
          id="Combined_Shape_Copy_2"
          data-name="Combined Shape Copy 2"
          d="M6.175,13.658a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.658a1.167,1.167,0,0,1-1.65,0Z"
          transform="translate(0 0)"
          fill="#00aeef"
        />
      </svg>

      <a class="flex-box uppercase" :href="_.get(data, 'moreLink.url')">
        {{ _.get(data, "moreLink.title") }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data", "evenOdd", "noRoute"]
};
</script>

<style lang="scss">
.image-with-desc {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &__img {
    width: 100%;
    height: 250px;
    border-radius: 6px;
    margin-bottom: 37px;
    position: relative;
    cursor: pointer;
    display: block;
    img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 6px;
    }
  }
  &__title {
    cursor: pointer;
    display: block;
  }
  &__teaser {
    margin-top: 14px;
    padding-right: 20px;
  }
  .view-more {
    margin-top: 15px;
  }
}
</style>
